import { IStoreData } from '~api/DataMappings';
import { fieldNamePlaceholderRegex } from '~constants/Constants';

enum TextPartType {
    TEXT,
    SUBSTITUTION
}

interface ITextPart {
    type: TextPartType;
    // TODO: APACFTRS1-770 why is this an unknown type?
    value: unknown;
}

// Divide original message into parts of text and substitution
const getTextParts = (message: string = ''): ITextPart[] => {
    const result: ITextPart[] = [];

    let text = message;
    let match = text.match(fieldNamePlaceholderRegex);
    while (match) {
        const index = match.index;

        // normal text
        if (index && index > 0) {
            result.push({
                type: TextPartType.TEXT,
                value: text.substr(0, match.index)
            });
        }

        // substitution
        if (index !== undefined && index >= 0) {
            result.push({
                type: TextPartType.SUBSTITUTION,
                value: match[1]
            });
        }

        // next part of the text
        if (index !== undefined) {
            text = text.substr(index + match[0].length);
            match = text.match(fieldNamePlaceholderRegex);
        } else {
            match = null;
        }
    }
    if (text.length) {
        result.push({
            value: text,
            type: TextPartType.TEXT
        });
    }

    return result;
};

export const handlePlaceholderValues = (
    text: string,
    formData: IStoreData,
    returnEmptyIfNoPlaceholderSource: boolean = false
) => {
    const textParts = getTextParts(text);
    if (!textParts.some((part) => part.type === TextPartType.SUBSTITUTION)) {
        return text;
    }

    // If all the placeholders have no value in formData, then return ''
    if (
        returnEmptyIfNoPlaceholderSource &&
        textParts
            .filter(({ type }) => type === TextPartType.SUBSTITUTION)
            .every(({ value }) => !formData[value as string])
    ) {
        return '';
    }

    return textParts
        .map((part) => {
            if (part.type === TextPartType.TEXT) {
                // TODO: APACFTRS1-770 is it possible to be undefined/null
                return part.value || '';
            } else {
                return formData[part.value as string]?.toString() || '';
            }
        })
        .join('');
};
